import React from 'react';
// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Link from '@nmx/template/dist/componentLibrary/components/Link';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
// styles
import {
  RowStyled,
  TypographyStyled,
} from './styles';

export default ({ errorCode, errorMessage }) => {
  return (
    <SectionContainer
      id='404-page'
      backgroundVariant='lightA'
      themeType='lightTheme'
      disableBottomPadding>
      <RowStyled align='center'>
        <Col
          medium={10}
          large={8}
          align='center'>
          <TypographyStyled
            component='h1'
            variant='jumbo-type'
            align='center'
            nextElement='typography'>
            {errorCode}
          </TypographyStyled>
          <Typography
            variant='h2'
            disableBottomPadding>
            {errorMessage}
          </Typography>
        </Col>
      </RowStyled>
      <Row align='center'>
        <Col
          medium={10}
          large={8}
          align='center'>
          <Typography
            variant='h5'
            align='center'
            nextElement='button'>
            <Typography
              component='span'
              disableBottomPadding
              block>
              Can&#39;t find what you&#39;re looking for&#63;
            </Typography>
            <Typography
              component='span'
              disableBottomPadding
              block>
              Click below for a map of our site.
            </Typography>
          </Typography>
          <Link
            id='404-page-sitemap-link'
            variant='buttonLinkPrimary'
            linkUrl='/sitemap/'>
            Site map
          </Link>
        </Col>
      </Row>
    </SectionContainer>
  );
};
